import { render } from "./trips.vue?vue&type=template&id=735e90f8"
import script from "./trips.vue?vue&type=script&lang=js"
export * from "./trips.vue?vue&type=script&lang=js"

import "./trips.vue?vue&type=style&index=0&id=735e90f8&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__